import { useNavigate } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";

export const TermsAndConditions = () => {
    const navigateTo = useNavigate();
    return (
        <div className="page-body flx-col">
            <SiteHeader
                title={"Kontakt"}
                navAction={() => {
                    navigateTo("/", { state: "service" })
                }}
            />
            <div className="app-body flx-col">
                <div className="upper-page">
                    <div className="service-call-container flx-rw c-al c-jt">
                        <span className="prim-dot" ></span>
                        <div className="service-text">
                            Rechtliches
                        </div>
                    </div>
                    <div className="page-title">
                        Allgemeine Geschäftsbedingungen
                    </div>
                    <div className="title-context">
                        Informationen zur Verarbeitung Ihrer personenbezogenen Daten nach Art. 13, 14 DSGVO.
                    </div>
                </div>
            </div>
        </div>
    )
}